(function () {
  'use strict';

  /* Guard: snippet se renderiza 1× por tarjeta → script carga N veces.
     Solo la primera ejecución registra listeners y crea el modal. */
  if (window.MFQuickAddInited) return;
  window.MFQuickAddInited = true;

  var modal = null;
  var currentProduct = null;
  var selectedOptions = {};
  var LOW_STOCK_HIGH = 15;
  var LOW_STOCK_MID = 9;
  var LOW_STOCK_COUNT = 3;

  /* ---------- Cart ---------- */
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function openCart() {
    if (window.MFCart) {
      window.MFCart.renderContents().then(function () { window.MFCart.open(); });
    } else {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () { if (window.MFCart) window.MFCart.open(); }, 600);
    }
  }

  /* =====================================================
     DIRECT ADD (sin variantes)
     ===================================================== */
  function handleDirectAdd(btn) {
    if (btn.dataset.loading) return;
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    var origText = btn.textContent;
    btn.dataset.loading = '1';
    btn.disabled = true;
    btn.textContent = '...';

    addToCart(variantId, 1)
      .then(function () {
        btn.textContent = '✓ AÑADIDO';
        btn.classList.add('is-added');
        openCart();
        setTimeout(function () {
          btn.textContent = origText;
          btn.classList.remove('is-added');
          btn.disabled = false;
          delete btn.dataset.loading;
        }, 2200);
      })
      .catch(function (err) {
        console.error('[MF Quick Add]', err);
        btn.textContent = '✗ Error';
        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled = false;
          delete btn.dataset.loading;
        }, 2000);
      });
  }

  /* =====================================================
     MODAL (con variantes)
     El wrapper .mf-qa-modal ES el overlay semi-transparente.
     Clic fuera de .mf-qa-modal__inner = cerrar.
     ===================================================== */
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, '${{amount_no_decimals}}');
    }
    return '$' + Math.floor(cents / 100).toLocaleString('es-CO') + ',00 COP';
  }

  var TRUCK_ICON = '<svg class="mf-go-promo-notice__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var BELL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="15" height="15" style="flex-shrink:0"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
  var NOTIFY_ENDPOINT = 'https://mf-back-in-stock.mundofit.workers.dev/subscribe';

  function buildModalHTML() {
    return [
      '<div class="mf-qa-modal__container">',
      '<div class="mf-qa-modal__inner">',
        '<button class="mf-qa-modal__close" aria-label="Cerrar">✕</button>',
        '<div class="mf-qa-modal__image-col">',
          '<img class="mf-qa-modal__img" src="" alt="" width="400" height="400" loading="eager">',
        '</div>',
        '<div class="mf-qa-modal__info-col">',
          '<p class="mf-qa-modal__vendor"></p>',
          '<h2 class="mf-qa-modal__title"></h2>',
          /* Precio — estructura PDP */
          '<div class="mf-ph-price">',
            '<div class="mf-ph-price__amounts">',
              '<span class="mf-ph-price__current" data-qa-price-current></span>',
              '<div>',
                '<span class="mf-ph-price__compare" data-qa-price-compare style="display:none"></span>',
                '<span class="mf-ph-badge-sale" data-qa-price-badge style="display:none"></span>',
              '</div>',
            '</div>',
          '</div>',
          '<p class="mf-qa-modal__shipping-note">Impuestos incluidos. Los <a href="/policies/shipping-policy">gastos de envío</a> se calculan en la pantalla de pago.</p>',
          /* GO promo notice */
          '<div class="mf-go-promo-notice" data-qa-go-promo>',
            TRUCK_ICON,
            '<span>Compra cualquier producto <a href="/collections/linea-de-productos-go-company"><strong>GO Company</strong></a> y obtén <strong>envío gratis</strong> en todo el país.</span>',
          '</div>',
          /* Variantes — estructura PDP */
          '<div class="mf-ph-variants"><div class="mf-ph-optgroups" data-qa-optgroups></div></div>',
          /* Cantidad */
          '<div class="mf-ph-qty-row">',
            '<span class="mf-ph-field-label">Cantidad</span>',
            '<div class="mf-ph-qty">',
              '<button type="button" data-qa-qty-minus aria-label="Disminuir">−</button>',
              '<input type="number" data-qa-qty-input value="1" min="1" max="10" inputmode="numeric" pattern="[0-9]*">',
              '<button type="button" data-qa-qty-plus aria-label="Aumentar">+</button>',
            '</div>',
          '</div>',
          /* Low stock */
          '<div class="mf-ph-low-stock" data-qa-low-stock></div>',
          /* Botones */
          '<button type="button" class="mf-ph-btn mf-ph-btn--secondary" data-qa-add-btn>Añadir</button>',
          '<button type="button" class="mf-ph-btn mf-ph-btn--primary" data-qa-buy-btn>Comprar ahora</button>',
          /* Agotado + notificación back-in-stock */
          '<div class="mf-qa-oos" data-qa-oos style="display:none">',
            '<p class="mf-qa-oos__msg">Esta combinación está agotada.</p>',
            '<button type="button" class="mf-qa-oos__notify-trigger" data-qa-notify-trigger aria-expanded="false">',
              BELL_ICON,
              '<span>Avísame cuando esté disponible</span>',
            '</button>',
            '<div class="mf-qa-oos__notify-panel" data-qa-notify-panel hidden>',
              '<p class="mf-qa-oos__notify-label">Te avisamos por correo apenas vuelva a estar disponible.</p>',
              '<form class="mf-qa-oos__notify-form" data-qa-notify-form>',
                '<input type="email" class="mf-qa-oos__notify-email" data-qa-notify-email placeholder="tu@correo.com" required autocomplete="email">',
                '<button type="submit" class="mf-qa-oos__notify-submit">AVÍSAME</button>',
              '</form>',
              '<p class="mf-qa-oos__notify-msg" data-qa-notify-msg hidden></p>',
            '</div>',
          '</div>',
          /* Trust */
          '<div class="mf-qa-modal__trust">',
            '<span class="mf-qa-modal__trust-item"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>Productos 100% originales</span>',
            '<span class="mf-qa-modal__trust-item"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Pago 100% seguro</span>',
            '<span class="mf-qa-modal__trust-item"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>Devolución garantizada</span>',
          '</div>',
          '<a class="mf-qa-modal__details-link" href="#" data-qa-details-link>Ver todos los detalles →</a>',
        '</div>',
      '</div>',
      /* Cross-sell — fuera del card, debajo */
      '<div class="mf-qa-cs" data-qa-cs style="display:none">',
        '<span class="mf-ph-field-label mf-qa-cs__label">Complementa tu compra</span>',
        '<div class="mf-qa-cs__grid" data-qa-cs-grid></div>',
      '</div>',
      '</div>', /* cierra __container */
    ].join('');
  }

  function getModal() {
    if (modal) return modal;
    modal = document.querySelector('.mf-qa-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'mf-qa-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Seleccionar opciones de producto');
      modal.innerHTML = buildModalHTML();
      document.body.appendChild(modal);
    }

    /* Cerrar al hacer clic en el overlay (fuera del container) */
    modal.addEventListener('click', function (e) {
      if (!modal.querySelector('.mf-qa-modal__container').contains(e.target)) closeModal();
    });

    modal.querySelector('.mf-qa-modal__close').addEventListener('click', closeModal);

    modal.querySelector('[data-qa-qty-minus]').addEventListener('click', function () {
      var inp = modal.querySelector('[data-qa-qty-input]');
      inp.value = Math.max(1, parseInt(inp.value, 10) - 1);
    });
    modal.querySelector('[data-qa-qty-plus]').addEventListener('click', function () {
      var inp = modal.querySelector('[data-qa-qty-input]');
      inp.value = Math.min(10, parseInt(inp.value, 10) + 1);
    });

    modal.querySelector('[data-qa-add-btn]').addEventListener('click', handleModalAdd);
    modal.querySelector('[data-qa-buy-btn]').addEventListener('click', handleModalBuyNow);

    /* OOS notify toggle */
    modal.querySelector('[data-qa-notify-trigger]').addEventListener('click', function () {
      var panel = modal.querySelector('[data-qa-notify-panel]');
      var isOpen = !panel.hasAttribute('hidden');
      if (isOpen) {
        panel.setAttribute('hidden', '');
        modal.querySelector('[data-qa-notify-trigger]').setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        modal.querySelector('[data-qa-notify-trigger]').setAttribute('aria-expanded', 'true');
        modal.querySelector('[data-qa-notify-email]').focus();
      }
    });

    /* OOS notify form submit */
    modal.querySelector('[data-qa-notify-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var emailEl = modal.querySelector('[data-qa-notify-email]');
      var msgEl = modal.querySelector('[data-qa-notify-msg]');
      var submit = modal.querySelector('[data-qa-notify-form] [type="submit"]');
      var addr = (emailEl.value || '').trim();
      if (!addr) return;

      var v = getCurrentVariant();
      if (submit) submit.disabled = true;
      showNotifyMsg(msgEl, 'Enviando…', '');

      fetch(NOTIFY_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: addr,
          variant_id: v ? String(v.id) : '',
          product_title: currentProduct ? currentProduct.title : '',
          product_url: currentProduct ? (window.location.origin + currentProduct.url) : '',
          product_image: currentProduct ? (currentProduct.featured_image || '') : ''
        })
      })
        .then(function (res) {
          if (res.ok) {
            showNotifyMsg(msgEl, '¡Listo! Te avisaremos por correo apenas vuelva.', 'ok');
            e.target.reset();
          } else {
            showNotifyMsg(msgEl, 'No pudimos registrarte. Intenta de nuevo.', 'err');
          }
        })
        .catch(function () {
          showNotifyMsg(msgEl, 'Error de conexión. Intenta de nuevo.', 'err');
        })
        .then(function () {
          if (submit) submit.disabled = false;
        });
    });

    modal.querySelector('[data-qa-optgroups]').addEventListener('click', function (e) {
      var chip = e.target.closest('.mf-ph-chip');
      if (!chip) return;
      selectOption(chip.dataset.optionName, chip.dataset.optionValue);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });

    return modal;
  }

  function openModal(productId) {
    var dataEl = document.querySelector('[data-mf-product-json="' + productId + '"]');
    if (!dataEl) return;
    try { currentProduct = JSON.parse(dataEl.textContent); }
    catch (e) { console.error('[MF Quick Add] Bad product JSON', e); return; }

    selectedOptions = {};
    if (currentProduct.options) {
      currentProduct.options.forEach(function (opt) {
        selectedOptions[opt.name] = opt.values[0];
      });
    }

    populateModal();
    getModal().classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    if (modal) modal.classList.remove('is-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    currentProduct = null;
    selectedOptions = {};
  }

  /* ---- Populate ---- */
  function populateModal() {
    var m = getModal();
    m.querySelector('.mf-qa-modal__vendor').textContent = currentProduct.vendor || '';
    m.querySelector('.mf-qa-modal__title').textContent = currentProduct.title;
    m.querySelector('[data-qa-details-link]').href = currentProduct.url;
    m.querySelector('[data-qa-qty-input]').value = 1;
    updateImage();
    updatePrice();
    renderOptions();
    updateAvailability();
    updateLowStock();
    /* reset notify panel */
    var notifyPanel = m.querySelector('[data-qa-notify-panel]');
    if (notifyPanel) notifyPanel.setAttribute('hidden', '');
    var notifyEmail = m.querySelector('[data-qa-notify-email]');
    if (notifyEmail) notifyEmail.value = '';
    var notifyMsg = m.querySelector('[data-qa-notify-msg]');
    if (notifyMsg) { notifyMsg.setAttribute('hidden', ''); notifyMsg.textContent = ''; }
    var notifyTrigger = m.querySelector('[data-qa-notify-trigger]');
    if (notifyTrigger) notifyTrigger.setAttribute('aria-expanded', 'false');
    loadCrossSell(currentProduct.id);
  }

  /* ---- Cross-sell ---- */
  function fmtApiPrice(price) {
    /* Prices from /recommendations/products.json are in Shopify cents */
    return fmtMoney(Math.round(parseFloat(price)));
  }

  function renderCsCard(p) {
    var v = p.variants[0];
    var price = parseFloat(v.price);
    var compare = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
    var onSale = compare > price;
    var pct = onSale ? Math.round((compare - price) / compare * 100) : 0;
    var img = '';
    if (p.featured_image) {
      img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
    }
    if (!img && p.images && p.images.length) {
      img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    }
    var imgSrc = img ? img.replace(/\?.*$/, '') + '?width=160' : '';

    return '<div class="mf-ph-cs-card" data-cs-variant-id="' + v.id + '" data-cs-price="' + price + '">' +
      '<a href="' + esc(p.url) + '" class="mf-ph-cs-card__img"><img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy" width="80" height="80"></a>' +
      '<div class="mf-ph-cs-card__info">' +
        '<a href="' + esc(p.url) + '" class="mf-ph-cs-card__title">' + esc(p.title) + '</a>' +
        '<div class="mf-ph-cs-card__prices">' +
          (onSale ? '<span class="mf-ph-cs-card__compare">' + fmtApiPrice(compare) + '</span>' : '') +
          '<span class="mf-ph-cs-card__price">' + fmtApiPrice(price) + '</span>' +
          (onSale ? '<span class="mf-ph-cs-card__badge">' + pct + '% OFF</span>' : '') +
        '</div>' +
        '<div class="mf-ph-cs-card__actions">' +
          '<button type="button" class="mf-ph-cs-card__add" data-qa-cs-add>AGREGAR</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function loadCrossSell(productId) {
    var m = getModal();
    var container = m.querySelector('[data-qa-cs]');
    var grid = m.querySelector('[data-qa-cs-grid]');
    if (!container || !grid) return;
    container.style.display = 'none';
    grid.innerHTML = '';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || [])
          .filter(function (p) { return p.id !== productId; })
          .slice(0, 3);
        if (!products.length) return;

        grid.innerHTML = products.map(renderCsCard).join('');
        container.style.display = '';

        grid.querySelectorAll('[data-qa-cs-add]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var card = btn.closest('.mf-ph-cs-card');
            var variantId = parseInt(card.dataset.csVariantId, 10);
            if (!variantId) return;
            var orig = btn.textContent;
            btn.disabled = true;
            btn.classList.add('is-loading');
            addToCart(variantId, 1)
              .then(function () {
                btn.classList.remove('is-loading');
                btn.classList.add('is-added');
                btn.textContent = '✓ AÑADIDO';
                openCart();
                setTimeout(function () {
                  btn.classList.remove('is-added');
                  btn.textContent = orig;
                  btn.disabled = false;
                }, 2000);
              })
              .catch(function () {
                btn.classList.remove('is-loading');
                btn.classList.add('is-error');
                btn.textContent = '✗ ERROR';
                setTimeout(function () {
                  btn.classList.remove('is-error');
                  btn.textContent = orig;
                  btn.disabled = false;
                }, 2000);
              });
          });
        });
      })
      .catch(function () { /* silent — cross-sell es opcional */ });
  }

  function updateImage() {
    var img = getModal().querySelector('.mf-qa-modal__img');
    var v = getCurrentVariant();
    img.src = (v && v.featured_image) ? v.featured_image : (currentProduct.featured_image || '');
    img.alt = currentProduct.title;
  }

  function updatePrice() {
    var m = getModal();
    var v = getCurrentVariant();
    if (!v) return;

    m.querySelector('[data-qa-price-current]').textContent = fmtMoney(v.price);

    var compare = m.querySelector('[data-qa-price-compare]');
    var badge = m.querySelector('[data-qa-price-badge]');

    if (v.compare_at_price && v.compare_at_price > v.price) {
      compare.textContent = fmtMoney(v.compare_at_price);
      compare.style.display = '';
      badge.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF';
      badge.style.display = '';
    } else {
      compare.style.display = 'none';
      badge.style.display = 'none';
    }
  }

  function renderOptions() {
    var container = getModal().querySelector('[data-qa-optgroups]');
    if (!currentProduct.options || !currentProduct.options.length) { container.innerHTML = ''; return; }

    container.innerHTML = currentProduct.options.map(function (opt) {
      var pills = opt.values.map(function (val) {
        var active = selectedOptions[opt.name] === val ? ' is-active' : '';
        return '<button type="button" class="mf-ph-chip' + active + '" ' +
          'data-option-name="' + esc(opt.name) + '" data-option-value="' + esc(val) + '">' +
          esc(val) + '</button>';
      }).join('');
      return '<div class="mf-ph-optgroup"><span class="mf-ph-field-label">' + esc(opt.name) +
        '</span><div class="mf-ph-variant-chips">' + pills + '</div></div>';
    }).join('');
  }

  function showNotifyMsg(el, text, kind) {
    if (!el) return;
    el.textContent = text;
    el.removeAttribute('hidden');
    el.className = 'mf-qa-oos__notify-msg' + (kind ? ' is-' + kind : '');
  }

  function updateAvailability() {
    var m = getModal();
    var v = getCurrentVariant();
    var available = !!(v && v.available);

    var addBtn = m.querySelector('[data-qa-add-btn]');
    var buyBtn = m.querySelector('[data-qa-buy-btn]');
    var qtyRow = m.querySelector('.mf-ph-qty-row');
    var lowStock = m.querySelector('[data-qa-low-stock]');
    var oosEl = m.querySelector('[data-qa-oos]');

    addBtn.disabled = !available;
    addBtn.textContent = available ? 'Añadir' : 'AGOTADO';
    if (buyBtn) {
      buyBtn.disabled = !available;
      buyBtn.style.display = available ? '' : 'none';
    }
    if (qtyRow) qtyRow.style.display = available ? '' : 'none';
    if (lowStock) lowStock.style.display = available ? '' : 'none';
    if (oosEl) oosEl.style.display = available ? 'none' : '';

    /* Marcar chips sin stock para la combinación actual */
    if (!currentProduct || !currentProduct.options) return;
    currentProduct.options.forEach(function (opt, optIdx) {
      opt.values.forEach(function (val) {
        var anyAvailable = currentProduct.variants.some(function (vr) {
          return vr.available && vr.options.every(function (vVal, i) {
            if (i === optIdx) return vVal === val;
            if (i > optIdx) return true; /* opciones siguientes no restringen */
            var name = currentProduct.options[i] && currentProduct.options[i].name;
            return !name || !selectedOptions[name] || selectedOptions[name] === vVal;
          });
        });
        var chip = m.querySelector(
          '[data-option-name="' + opt.name.replace(/"/g, '\\"') + '"]' +
          '[data-option-value="' + val.replace(/"/g, '\\"') + '"]'
        );
        if (chip) chip.classList.toggle('is-unavailable', !anyAvailable);
      });
    });
  }

  function updateLowStock() {
    var container = getModal().querySelector('[data-qa-low-stock]');
    if (!container) return;
    var v = getCurrentVariant();
    var qty = v && v.inventory_quantity;
    if (!v || v.inventory_management !== 'shopify' || !qty || qty <= 0 || qty > LOW_STOCK_HIGH) {
      container.innerHTML = '';
      return;
    }
    var text = qty <= LOW_STOCK_COUNT
      ? '¡Solo quedan ' + qty + ' unidades!'
      : qty <= LOW_STOCK_MID
        ? '¡Últimas unidades — no esperes más!'
        : 'Apúrate, quedan pocas unidades';
    container.innerHTML = '<span class="mf-low-stock-badge">' + esc(text) + '</span>';
  }

  function selectOption(optionName, optionValue) {
    selectedOptions[optionName] = optionValue;
    getModal().querySelectorAll('[data-option-name="' + optionName + '"]').forEach(function (chip) {
      chip.classList.toggle('is-active', chip.dataset.optionValue === optionValue);
    });
    updateImage();
    updatePrice();
    updateAvailability();
    updateLowStock();
  }

  function getCurrentVariant() {
    if (!currentProduct || !currentProduct.variants) return null;
    var opts = currentProduct.options || [];
    return currentProduct.variants.find(function (v) {
      return v.options.every(function (val, i) {
        var name = opts[i] && opts[i].name;
        return !name || !selectedOptions[name] || selectedOptions[name] === val;
      });
    }) || currentProduct.variants[0];
  }

  function handleModalAdd() {
    var v = getCurrentVariant();
    if (!v || !v.available) return;
    var m = getModal();
    var btn = m.querySelector('[data-qa-add-btn]');
    var qty = parseInt(m.querySelector('[data-qa-qty-input]').value, 10) || 1;

    btn.classList.add('is-loading');
    btn.disabled = true;

    addToCart(v.id, qty)
      .then(function () {
        btn.classList.remove('is-loading');
        closeModal();
        openCart();
      })
      .catch(function (err) {
        console.error('[MF Quick Add] Modal add error', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = '✗ Error';
        setTimeout(function () { btn.textContent = 'Añadir'; }, 2000);
      });
  }

  /* Mismo patron que "Comprar ahora" del PDP (mf-product-hero.js):
     agrega la variante elegida y salta directo a checkout. */
  function handleModalBuyNow() {
    var v = getCurrentVariant();
    if (!v || !v.available) return;
    var m = getModal();
    var btn = m.querySelector('[data-qa-buy-btn]');
    var qty = parseInt(m.querySelector('[data-qa-qty-input]').value, 10) || 1;

    btn.classList.add('is-loading');
    btn.disabled = true;

    addToCart(v.id, qty)
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[MF Quick Add] Modal buy now error', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = '✗ Error';
        setTimeout(function () { btn.textContent = 'Comprar ahora'; }, 2000);
      });
  }

  /* =====================================================
     INIT
     ===================================================== */
  function init() {
    document.addEventListener('click', function (e) {
      var directBtn = e.target.closest('.mf-quick-add-direct');
      if (directBtn) { e.preventDefault(); handleDirectAdd(directBtn); return; }

      var modalBtn = e.target.closest('.mf-quick-add-modal');
      if (modalBtn) { e.preventDefault(); openModal(modalBtn.dataset.productId); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
